import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#ueber-mich", label: "Über mich" },
  { href: "#angebote", label: "Angebote" },
  { href: "#kunst", label: "Meine Kunst" },
  { href: "#kontakt", label: "Kontakt" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeAnd = (fn) => () => {
    setOpen(false);
    fn && fn();
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-cream/85 backdrop-blur-md border-b border-ink/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand" className="group flex items-center gap-3">
          <span className="w-9 h-9 rounded-full bg-terracotta flex items-center justify-center text-cream font-serif-elegant text-lg leading-none">
            k
          </span>
          <span className="font-serif-elegant text-xl md:text-2xl text-ocean leading-none">
            Kerstin Cloodt
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm tracking-wide text-ink/75 hover:text-terracotta transition-colors relative after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 hover:after:w-full after:h-px after:bg-terracotta after:transition-all after:duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#kontakt"
            data-testid="nav-cta-contact"
            className="text-sm px-5 py-2.5 rounded-full bg-ocean text-cream hover:bg-terracotta transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
          >
            Termin anfragen
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-ocean"
          aria-label="Menü"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            className="md:hidden mx-6 mt-3 rounded-2xl bg-cream/95 backdrop-blur-md border border-ink/10 shadow-lg overflow-hidden"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col p-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={closeAnd()}
                  data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
                  className="py-3 px-2 text-ink hover:text-terracotta border-b border-ink/5 last:border-none"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
